export const GET_ONBOARDING_QUESTIONS_SUCCEED = 'onboardingQuestions/GET_ONBOARDING_QUESTIONS_SUCCEED';
export const GET_ONBOARDING_QUESTIONS_ERROR = 'onboardingQuestions/GET_ONBOARDING_QUESTIONS_ERROR';
export const LOADING_QUESTIONS_STATE = 'onboardingQuestions/LOADING_QUESTIONS_STATE';

export const GET_ONBOARDING_RESPONSES_SUCCEED = 'onboardingQuestions/GET_ONBOARDING_RESPONSES_SUCCEED';
export const GET_ONBOARDING_RESPONSES_ERROR = 'onboardingQuestions/GET_ONBOARDING_RESPONSES_ERROR';
export const LOADING_RESPONCES_STATE = 'onboardingQuestions/LOADING_RESPONCES_STATE';

export const GET_AGREEMENT_SUCCEED = "onboardingQuestions/GET_AGREEMENT_SUCCEED";
export const GET_AGREEMENT_ERROR = "onboardingQuestions/GET_AGREEMENT_ERROR";
export const LOADING_AGREEMENT_STATE = "onboardingQuestions/LOADING_AGREEMENT_STATE";

export const GET_CLIENT_AGREEMENT_SIGNATURE_SUCCEED = "onboardingQuestions/GET_CLIENT_AGREEMENT_SIGNATURE_SUCCEED";
export const GET_CLIENT_AGREEMENT_SIGNATURE_ERROR = "onboardingQuestions/GET_CLIENT_AGREEMENT_SIGNATURE_ERROR";
export const LOADING_CLIENT_AGREEMENT_SIGNATURE = "onboardingQuestions/LOADING_CLIENT_AGREEMENT_SIGNATURE";